<div class="customers-batch-uploads-card">
  <div ubi-curve-header class="customers-batch-uploads-card__header">
    <div class="customers-batch-uploads-card__header-text">
      {{ 'customers_batch_uploads.header' | translate }}
    </div>
  </div>

  <artemis-popover>
    {{ 'customers_batch_uploads.hint' | translate }}
  </artemis-popover>

  <div class="customers-batch-uploads-card__content">
    <div class="customers-batch-uploads-table__container">
      <artemis-loading-spinner *ngIf="(customersBatchUploadsHistoryDataSource.isLoading$ | async) && paginator.length === 0 &&
                                      !customersBatchUploadsHistoryDataSource.isFirstTimeLoaded">
      </artemis-loading-spinner>
      <div class="customers-batch-uploads-table__wrapper">
        <table class="custom-mat-table customers-batch-uploads-table" mat-table [dataSource]="customersBatchUploadsHistoryDataSource" matSort>

          <!-- Batch Upload Id -->
          <ng-container matColumnDef="id">
            <th class="customers-batch-uploads-table__column_id" mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'general.table.label.id' | translate }} </th>
            <td class="customers-batch-uploads-table__column_id" mat-cell *matCellDef="let file"> {{ file.id }} </td>
          </ng-container>

          <!-- File link -->
          <ng-container matColumnDef="file">
            <th class="customers-batch-uploads-table__column_file-name" mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'general.table.label.file' | translate }} </th>
            <td class="customers-batch-uploads-table__column_file-name" mat-cell *matCellDef="let file">
              <a class="link link_underlined link_accent" title="View file" target="_blank" [href]="file.file">
                {{ file.fileName }}
              </a>
            </td>
          </ng-container>

          <!-- Status -->
          <ng-container matColumnDef="processed">
            <th class="customers-batch-uploads-table__column_status" mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'general.table.label.status' | translate }}  </th>
            <td class="customers-batch-uploads-table__column_status" mat-cell *matCellDef="let file"
                [ngClass]="{'customers-batch-uploads-table__cell_accent': !file.processed,
                            'customers-batch-uploads-table__cell_green': file.processed && file.success,
                            'customers-batch-uploads-table__cell_alert': file.processed && !file.success}">
              {{ file.processed ? (file.success ? 'Success' : (file.errorMessage ? file.errorMessage : 'Error Occured') ) : 'In Progress' }}
            </td>
          </ng-container>

          <!-- Uploaded -->
          <ng-container matColumnDef="created_at">
            <th class="customers-batch-uploads-table__column_created-at" mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'general.table.label.uploaded' | translate }}  </th>
            <td class="customers-batch-uploads-table__column_created-at" mat-cell *matCellDef="let file"
                [title]="file.createdAt ? ((file.createdAt | date:'dd/MM/yyyy \'at\' h:mm:ss a') + ' by ' + (file.createdBy?.name || '--')) : ''">
              {{ file.createdAt ? (file.createdAt | date:'dd/MM/yyyy \'at\' h:mm:ss a') : '' }} {{ 'general.table.label.by' | translate }}
              <span class="uppercase-text">{{ file.createdBy ? file.createdBy?.name || '--' : '' }}</span>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>

      <div class="table-empty" *ngIf="paginator.length === 0">
        {{ 'customers_batch_uploads.message' | translate }}
      </div>

      <mat-paginator class="custom-mat-paginator" showFirstLastButtons></mat-paginator>
    </div>
  </div>
</div>
